import React from "react";
import RefundsAPI_Json from "./RefundsAPIJSON/RefundsAPI_Json";
import FinalRefundsApiJson from "./RefundsAPIJSON/FinalRefundsApiJson";
import ResponseParameters_Json from "./RefundsAPIJSON/ResponseParameters_Json";

function RefundsAPI() {
  return (
    <div class="idocs-content">
      <div class="container">
        <div class="row">
          <div class="col-md-8">
            <section id="idocs_content" class="mt-20 mb-20">
              <h1> Refund API</h1>
              <hr />
            </section>

            <p>
            You can use the Refund API to initiate the refund for any transactions. 
            </p>

            <p>You can refund the amount fully or partially. </p>

            <p>
            Refund API uses JSON format and sent using RESTful Web Service. 
            </p>

            <p>
              <span className="para-blod">Aes256 Crypto logic</span> encrypts and decrypts the JSON Request and Response parameters, respectively. 
            </p>

            <p>
              <b>Iv- initialization vector</b> can be used along with the Encryption key for data encryption, and the value remains static, which is mentioned in the Integration kit 
            </p>

            <p>Please follow the below steps to process a refund at your end:</p>

            <p className="para-blod">Postman Collection</p>

            <p>
             
We are providing the postman collection to check the transaction status more easily. <b>Safexpay</b> team will share with you at the time of Integration. 
            </p>

            <p className="para-blod">
            Please find the credentials shared below to check the Status of the API flow:
            </p>

            <p className="para-blod">UAT Environment :</p>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr>
                  <td className="table-color">Live Status Post URL</td>
                  <td>
                    {/* <a href="  https://uatcheckout.safexpay.ae/ms-transaction-core-1-0/refundRedirection/initiateRefund">
                     
                      https://uatcheckout.safexpay.ae/ms-transaction-core-1-0/refundRedirection/initiateRefund
                    </a> */}
                    <span>  https://uatcheckout.safexpay.ae/ms-transaction-core-1-0/refundRedirection/initiateRefund   </span>
                  </td>
                </tr>
                <tr>
                  <td className="table-color">UAT Merchant ID</td>
                  <td>202205240004</td>
                </tr>
                <tr>
                  <td className="table-color">UAT Encryption Key</td>
                  <td>j1C1iS53CGAIY3PDzJCTsMilKdjp14p7lTIWhc40xTI=</td>
                </tr>
                <tr>
                  <td className="table-color">Aggregator ID</td>
                  <td> paygate</td>
                </tr>
              </tbody>
            </table>

            <p className="para-blod">Production Environment :</p>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr>
                  <td className="table-color">Live Status Post URL</td>
                  <td>
                    {/* <a href="https://pg.safexpay.ae/ms-transaction-core-1-0/refundRedirection/initiateRefund">
                      https://pg.safexpay.ae/ms-transaction-core-1-0/refundRedirection/initiateRefund
                    </a> */}
                    <span>https://pg.safexpay.ae/ms-transaction-core-1-0/refundRedirection/initiateRefund</span>
                  </td>
                </tr>
                <tr>
                  <td className="table-color">Live Merchant ID</td>
                  <td>Shared by Safexpay</td>
                </tr>
                <tr>
                  <td className="table-color">Live Encryption Key</td>
                  <td>Shared by Safexpay</td>
                </tr>
                <tr>
                  <td className="table-color">Aggregator ID</td>
                  <td> Paygate</td>
                </tr>
              </tbody>
            </table>

            <p className="para-blod">Request Parameters:</p>

            <p>
              Merchant must send the following parameters to <b>Safexpay</b> PG
              to check the Transaction status.
            </p>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr className="table-color">
                  <th>Parameter Name</th>
                  <th>Attribute Type</th>
                  <th> Mandatory</th>
                  <th>Description</th>
                </tr>
                <tr>
                  <td>ag_id</td>
                  <td>String</td>
                  <td>YES</td>
                  <td>Aggregator id is “paygate”</td>
                </tr>

                <tr>
                  <td>me_id</td>
                  <td>String</td>
                  <td>YES</td>
                  <td>MerchantID issued to you by Safexpay.</td>
                </tr>

                <tr>
                  <td>order_no</td>
                  <td>String</td>
                  <td>(Either order_no or ag_ref is required)</td>
                  <td>Your unique transactionOrder number.</td>
                </tr>

                <tr>
                  <td>ag_ref</td>
                  <td>String</td>
                  <td>(Either order_no or ag_ref is required)</td>
                  <td>
                    AG_ref id generated by the Safexpay during the transaction.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-4">
            <RefundsAPI_Json />
            <FinalRefundsApiJson />
            <ResponseParameters_Json />
          </div>
        </div>
      </div>
    </div>
  );
}
export default RefundsAPI;
